export default {"src":"/_next/static/media/cloud.7d02dd33.svg","height":32,"width":44,"blurWidth":0,"blurHeight":0};